import { Box, ButtonGroup } from '@ff-it/ui';
import { memo, type ReactElement } from 'react';

import { SelectionControls } from './SelectionControls';
import type { BlockDetails } from 'modules/campaign/block/types';
import { AddRowButton } from './AddRowButton';
import { useEntity } from 'components';
import { BlockNotice } from 'modules/campaign/block/BlockNotice';
import { MoreActionsButton } from './MoreActionsButton';
import { SettingsButton } from './SettingsButton';
import { ResolutionButton } from './ResolutionButton';
import { StrategyButton } from './StrategyButton';

export const Toolbar = memo(function Toolbar(): ReactElement {
  const { item: block } = useEntity<BlockDetails>();

  return (
    <Box mb="1" display="flex" pr="1">
      <SelectionControls />
      <Box mx="2" flexGrow={1}>
        <BlockNotice {...block} className="d-inline-block" />
      </Box>

      <Box display="flex" alignItems="center" gap="3">
        <ButtonGroup>
          <StrategyButton />
          <SettingsButton />
        </ButtonGroup>
        <ResolutionButton />
        <MoreActionsButton />
        <AddRowButton />
      </Box>
    </Box>
  );
});
